import { BASE_URL, STORAGE_SUF } from "../constants"
import { fetchWithAuth } from "../utils/fetchWithAuth"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export const login = async (
  web: string,
  loginData: {
    username: string
    password: string
  },
): Promise<any> => {
  try {
    const response = await fetchWithAuth(`${BASE_URL}/login-${suffix}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ web, loginData }),
    })
    return response
  } catch (error) {
    console.error("Error logging in", error)
    throw error
  }
}
